<template>

  <div class="dailyQuestion" v-loading="loading">
    <!-- 顶部 -->
    <div class="top">
      <div class="back" @click="back">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/daily/5.png" />
        <!-- <span>返回</span> -->
      </div>
      <div class="title oneEllipsis">{{ belongCourseTitleName }}</div>
      <div class="but pointer" @click="showSubmit" v-if="list.length && !isSubmit">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/daily/submit-icon.png" />
        <span>提交练习</span>
      </div>
      <div class="time" v-if="isSubmit">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/daily/time-1.png" class="time-icon" />
        <span>预计用时：</span>
        <span style="color: #ff5d51" class="mr28">{{ expectTime }}</span>
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/daily/time-1.png" class="time-icon" />
        <span>实际练习时长：</span>
        <span style="color: #ff5d51">{{ usedTime }}</span>
      </div>
    </div>

    <!-- 题目 -->
    <div class="question">
      <!-- 时间 -->

      <div class="mb20" v-for="(item, index) in list" :key="index">
        <dailyQuestion :index="index" :info="item" @answer="answer" />
      </div>
    </div>
    <!-- 交卷提示 -->
    <div class="mask-fixed submit" v-if="submitTips">
      <div class="submit-box">
        <!-- 未做完 -->
        <div class="submit-title" v-if="number.notDo != 0">
          <span>您还有</span>
          <span style="color: #ff5d51">{{ number.notDo }}道试题未作答</span>
          <span>是否提交？</span>
        </div>
        <!-- 全部做完 -->
        <div class="submit-title" v-else>您已完成全部试题，是否提交？</div>
        <!-- 按钮 -->
        <div class="submit-but">
          <div class="submit goon" @click="showSubmit">继续做题</div>
          <el-button class="submit sub" @click="submit" :loading="submitLoading"
            :disabled="submitLoading">确定提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Know } from "@/api/know";
// const know = new Know();

import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import dailyQuestion from "./dailyQuestion.vue";
export default {
  components: { dailyQuestion },

  data() {
    return {
      belongCourseTitleId: "",
      belongCourseTitleName: "",
      day: "",
      type: "", // 1做题2解析
      expectTime: "00:00", // 预计用时
      usedTime: "00:00", // 实际用时
      list: [],
      isSubmit: false, // 是否已交卷
      number: {
        total: 0,
        do: 0,
        notDo: 0,
      },
      loading: false, // 加载
      timer: null, // 答题定时器
      time: 0, // 秒数
      submitTips: false,
      submitLoading: false,
    };
  },
  created() {
    this.belongCourseTitleId = this.$route.query.belongCourseTitleId;
    this.belongCourseTitleName = this.$route.query.belongCourseTitleName;
    this.day = this.$route.query.day;
    this.type = this.$route.query.type;
    this.expectTime = this.$route.query.expectTime;

    if (this.type == 1) {
      this.getList();
    } else {
      this.getAnalysis();
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    setTimer() {
      this.clearTimer();
      this.timer = setInterval(() => {
        this.time++;
      }, 1000);
    },
    clearTimer() {
      clearInterval(this.timer);
    },
    getList() {
      this.loading = true;
      homeClient
        .getDailyPracticeTopic({
          belongCourseTitle: this.belongCourseTitleId,
          day: this.day,
        })
        .then((res) => {
          this.list = this.setData(res.data);
          this.number.total = this.list.length;
          this.setTimer();
          this.loading = false;
        });
    },
    setData(arr) {
      arr.forEach((item) => {
        item.questionType = Number(item.questionType);
        item.userAnswer = "";
        item.imgList = [];
        if ([1, 6].includes(item.questionType)) {
          item.userAnswer = [];
        }
        if (!item.questionOptionList) {
          item.questionOptionList = JSON.parse(item.questionOption);
        }
      });
      return arr;
    },
    timeDiff(time, isShowHour = true) {
      if (!time) {
        return {
          h: "00",
          m: "00",
          s: "00",
        };
      }

      let h = 0;
      let m = 0;
      if (time >= 60) {
        m = parseInt(time / 60 + "");
        time = parseInt((time % 60) + "");
        if (m >= 60 && isShowHour) {
          h = parseInt(m / 60 + "");
          m = parseInt((m % 60) + "");
        }
      }
      return {
        h: setZero(h),
        m: setZero(m),
        s: setZero(time),
      };
    },
    getAnalysis() {
      this.loading = true;

      homeClient
        .getDailyPracticeAnalysis2({
          belongCourseTitleId: this.belongCourseTitleId,
          day: this.day,
        })
        .then((res) => {
          this.isSubmit = true;
          const time = this.timeDiff(res.data.questionTime);
          this.usedTime = `${time.h != "00" ? time.h + ":" : ""}${time.m}:${time.s}`;
          this.list = this.setAnalysisList(res.data.practiceWrongList);
          this.loading = false;
        });
      // know
      //   .selectPracticeQuesByResultId({
      //     courseId: this.belongCourseTitleId,
      //     practiceDay: this.day,
      //   })
      //   .then((res) => {

      //   });
    },
    setAnalysisList(arr) {
      arr.forEach((item) => {
        item.isShowAnswer = true;
        item.questionType = Number(item.questionType);
        // 单选、判断
        if ([0, 2].includes(item.questionType)) {
          if (item.userAnswer) {
            item.isRight = item.questionAnswer == item.userAnswer;
            item.isAnswer = true;
          } else {
            item.isRight = false;
            item.isAnswer = false;
          }
        }
        // 多选、不定项
        if ([1, 6].includes(item.questionType)) {
          if (item.userAnswer) {
            item.isRight = item.questionAnswer == item.userAnswer;
            item.isAnswer = true;
            item.userAnswer = item.userAnswer
              .split(",")
              .filter((i) => i);
          } else {
            item.isRight = false;
            item.isAnswer = false;
            item.userAnswer = [];
          }
        }
        item.imgList = [];
        if ([3, 4].includes(item.questionType) && item.answerImg) {
          item.iList = JSON.parse(item.answerImg);
          let arr = [];
          item.iList.forEach((e) => {
            arr.push({ url: e.url, path: "" });
          });
          item.imgList = arr;
        }
        if (!item.questionOptionList) {
          item.questionOptionList = JSON.parse(item.questionOption);
        }
      });
      return arr;
    },
    answer(data) {
      if (this.isSubmit) return;
      const info = this.list[data.index];
      if ([0, 2].includes(info.questionType)) {
        // 单选题、判断题
        info.userAnswer = data.value;
      }
      if ([1, 6].includes(info.questionType)) {
        // 多选题、不定项选择
        if (!Array.isArray(info.userAnswer)) {
          info.userAnswer = info.userAnswer
            ? info.userAnswer.split(",")
            : [];
        }
        const idx = info.userAnswer.findIndex((i) => i == data.value);
        idx == -1
          ? info.userAnswer.push(data.value)
          : info.userAnswer.splice(idx, 1);
      }
      if ([3, 4].includes(info.questionType)) {
        // 填空题、简答题
        if (data.type == "text") {
          info.userAnswer = data.value;
        } else if (data.type == "delImg") {
          // 删除图片
          info.imgList.splice(data.value, 1);
        } else if (data.type == "uploadImg") {
          info.imgList = info.imgList.concat(data.value);
        }
      }
    },
    showSubmit() {
      if (this.submitLoading) return;
      this.submitTips = !this.submitTips;
    },
    submit() {
      this.submitLoading = true;
      this.clearTimer();
      homeClient
        .addUserDailyPracticeAnswer({
          belongCourseTitle: this.belongCourseTitleId,
          day: this.day,
          questionTime: this.time,
          practiceWrongList: this.list.map((item) => {
            if ([1, 6].includes(item.questionType)) {
              item.userAnswer = item.userAnswer
                .sort()
                .join(",");
            }
            if (item.imgList.length) {
              let arr = [];
              item.imgList.forEach((e) => {
                arr.push(e.url);
              });
              item.answerImg = JSON.stringify(arr);
            } else {
              item.answerImg = null;
            }
            return item;
          }),
        })
        .then((res) => {
          this.submitLoading = false;
          if (res.code == 0) {
            this.getAnalysis();
            this.showSubmit();
          }
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
    timeDiff(time, isShowHour = true) {
      if (!time) {
        return {
          h: "00",
          m: "00",
          s: "00",
        };
      }

      let h = 0;
      let m = 0;
      if (time >= 60) {
        m = parseInt(time / 60 + "");
        time = parseInt((time % 60) + "");
        if (m >= 60 && isShowHour) {
          h = parseInt(m / 60 + "");
          m = parseInt((m % 60) + "");
        }
      }
      return {
        h: this.setZero(h),
        m: this.setZero(m),
        s: this.setZero(time),
      };
    },
    setZero(value) {
      return value < 10 ? "0" + value : value;
    },
    exitStyleFixed() {
      const body = document.getElementsByTagName("body")[0];
      body.setAttribute("style", "zoom: 1");

      const app = document.getElementById("app");
      app.setAttribute("style", "");
    },
    setStyleFixed() {

      const body = document.getElementsByTagName("body")[0];
      const bodyStyleContent = body.getAttribute("style");
      body.setAttribute(
        "style",
        bodyStyleContent ? bodyStyleContent + bodyStyle : bodyStyle
      );

      const app = document.getElementById("app");
      const appStyleContent = app.getAttribute("style");
      app.setAttribute(
        "style",
        appStyleContent ? appStyleContent + appStyle : appStyle
      );
    },
  },
  watch: {
    submitTips: {
      handler(newVal) {
        if (newVal) {
          this.number.do = 0;
          this.list.forEach((item) => {
            if ([0, 2].includes(item.questionType) && item.userAnswer) {
              // 单选题、判断题
              this.number.do++;
            } else if (
              [1, 6].includes(item.questionType) &&
              item.userAnswer.length
            ) {
              // 多选题、不定项题
              this.number.do++;
            } else if (
              [3, 4].includes(item.questionType) &&
              (item.userAnswer || item.imgList.length)
            ) {
              // 简答题
              this.number.do++;
            }
          });
          this.number.notDo = this.number.total - this.number.do;

        } else {
          this.exitStyleFixed();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.dailyQuestion {
  height: 100%;
  // border-radius: 8px;
  overflow-x: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;

  .top {
    width: 100%;
    height: 70px;
    // box-shadow: 0px 3px 12px 1px rgba(204, 204, 204, 0.3);
    padding: 0 24px;
    display: flex;
    align-items: center;

    .back {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #777;
      cursor: pointer;
      width: 22px;
      height: 34px;
      background: #ffefee;
      border-radius: 11px 11px 11px 11px;

      img {
        display: block;
        width: 9px;
        height: 14px;
        // margin-right: 8px;
        // transform: translateY(2px);
      }
    }

    .title {
      flex: 1;
      color: #333;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 0 20px;
    }

    .but {
      width: 134px;
      height: 45px;
      border-radius: 24px;
      // background: linear-gradient(180deg, #97b2ff 0%, #3067ff 100%);
      background: #ff5d51;
      font-size: 15px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 13px;
        height: 15px;
        margin-right: 6px;
      }
    }
  }
}

.time {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #777;

  // margin-bottom: 20px;
  .time-icon {
    width: 15px;
    height: 15px;
    margin-right: 8px;
  }
}

.question {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  padding-top: 10px;

}

.submit {
  .submit-box {
    width: 374px;
    height: 152px;
    border-radius: 12px;
    background-color: #fff;

    .submit-title {
      font-size: 20px;
      color: #333;
      text-align: center;
      margin: 28px 0 32px;
    }

    .submit-but {
      display: flex;
      align-items: center;
      justify-content: center;

      .submit {
        width: 120px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        text-align: center;
        font-size: 16px;
        // font-weight: bold;
        margin: 0 10px;
        cursor: pointer;
      }

      .goon {
        background-color: #fff;
        border: 1px solid #ff5d51;
        color: #ff5d51;
      }

      .sub {
        background-color: #ff5d51;
        color: #fff;
        border: none;
      }
    }
  }
}
</style>
